module.exports = __webpack_public_path__ + "img/logo-full-gex.a5f0b5f0.png";